import styled from 'styled-components';

interface IContainer {
  cursor: 'pointer' | 'default';
}

export const Container = styled.button<IContainer>`
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  cursor: ${props => props.cursor};

  > div {
    display: flex;
    align-items: center;
  }

  > div svg {
    min-width: 30px;
  }

  > div > div {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  > div > div > span {
    font-size: 16px;
    color: var(--gray-9);
    text-align: left;
  }

  > div > div > strong {
    font-size: 16px;
    color: var(--black-2);
    text-align: left;
  }

  > strong {
    font-size: 14px;
    color: var(--black-2);
    text-align: left;
  }

  > div > div > span > i {
    font-size: 14px;
    color: var(--info);
    padding: 3px 4px;
    border-radius: 4px;
    background: var(--info-transparent);
    margin-left: 10px;
    font-style: normal;
  }
`;
